import { render, staticRenderFns } from "./asdkf.vue?vue&type=template&id=5ecbe24c&"
import script from "./asdkf.vue?vue&type=script&lang=js&"
export * from "./asdkf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports